import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {TYPE_COLLEGE, TYPE_UNDERGRADUATE, TAG_MEMBEROF} from '../constants'
import './Filter.less'
import { getCategory, getProvince,getSessionData }         from '../../../api/school'

class Filters extends Component {

    static propTypes = {
        onFilter: PropTypes.func,
        onHide: PropTypes.func,
    };
    _s_category_id__in=getSessionData('_s_category_id__in');
    _s_memberof=getSessionData('_s_memberof');
    _s_province_id__in=getSessionData('_s_province_id__in');
    _s_tag_211=getSessionData('_s_tag_211');
    _s_tag_double_top=getSessionData('_s_tag_double_top');
    _s_tag_985=getSessionData('_s_tag_985');
    _s_type=getSessionData('_s_type');
    state = {
        categories: [],
        provinces: [],
        area: '',
        category: '',
        type: '',
        tag985: false,
        tag211: false,
        tagDoubleTop:false,
        tagMemberof: false,
        filterItems:[],
        checkedList:[],
        levelList:[],
        provinceList:[],
        categoryList:[],
        disabledId:[],
    };
    componentDidMount() {
        let checkedList=[];
        if(this.props.filterItem==='level'){
            this.getLevelList();
            if(this._s_type==10){checkedList.push(10);this.setState({type:10});}
            if(this._s_type==20){checkedList.push(20);this.setState({type:20});}
            if(this._s_tag_211){checkedList.push(211);this.setState({tag211:true});}
            if(this._s_tag_985){checkedList.push(985);this.setState({tag985:true});}
            if(this._s_tag_double_top){checkedList.push(999);this.setState({tagDoubleTop:true});}
        }else if(this.props.filterItem==='province'){
            this.getProvinceList();
            if(this._s_province_id__in){checkedList=this._s_province_id__in.split(',');this.setState({area:this._s_province_id__in});}

        }else if(this.props.filterItem==='category'){
            this.getCategoryList();
            if(this._s_category_id__in){checkedList=this._s_category_id__in.split(',');this.setState({category:this._s_category_id__in});}
        }
        this.setState({checkedList})
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.filterItem==this.props.filterItem){

        }else {
            let checkedList=[];
            if(nextProps.filterItem==='level'){
                this.getLevelList();
                if(this._s_type==10){checkedList.push(10);this.setState({type:10});}
                if(this._s_type==20){checkedList.push(20);this.setState({type:20});}
                if(this._s_tag_211){checkedList.push(211);this.setState({tag211:true});}
                if(this._s_tag_985){checkedList.push(985);this.setState({tag985:true});}
                if(this._s_tag_double_top){checkedList.push(999);this.setState({tagDoubleTop:true});}
            }else if(nextProps.filterItem==='province'){
                this.getProvinceList();
                if(this._s_province_id__in){checkedList=this._s_province_id__in.split(',');this.setState({area:this._s_province_id__in});}

            }else if(nextProps.filterItem==='category'){
                this.getCategoryList();
                if(this._s_category_id__in){checkedList=this._s_category_id__in.split(',');this.setState({category:this._s_category_id__in});}
            }
            this.setState({checkedList})
        }
    }
    getLevelList(){
        let levelList=[{id:20,name:'本科'},{id:10,name:'专科'},{id:985,name:'985'},{id:211,name:'211'},{id:999,name:'双一流'},];
        this.setState({
            filterItems: levelList,
            levelList,
        })
    }
    getProvinceList(){
        getProvince().then(res => {
            this.setState({
                provinceList:res.data,
                filterItems: res.data,
            })
        })
    }
    getCategoryList(){
        getCategory().then(res => {
            this.setState({
                categoryList: res.data,
                filterItems: res.data,
            })
        })
    }
    handleFilter() {
        const {
            area,
            category,
            type,
            tag985,
            tag211,
            tagMemberof,
            tagDoubleTop,
        } = this.state;
        let filter={};
        if(this.props.filterItem ==='level'){
            filter = {
                _s_tag_985: tag985 || null,
                _s_tag_211: tag211 || null,
                _s_memberof: tagMemberof ? TAG_MEMBEROF : null,
                _s_type: type || null,
                _s_tag_double_top:tagDoubleTop ||null,
                _s_category_id__in: this._s_category_id__in ||null,
                _s_province_id__in: this._s_province_id__in ||null,
            };
        }else if(this.props.filterItem ==='province'){
            filter = {
                _s_province_id__in: area || null,
                _s_category_id__in: this._s_category_id__in ||null,
                _s_tag_985: this._s_tag_985 ||null,
                _s_tag_211: this._s_tag_211 ||null,
                _s_memberof: this._s_memberof ||null,
                _s_type: this._s_type ||null,
                _s_tag_double_top:this._s_tag_double_top ||null,
            };
        }else if(this.props.filterItem ==='category'){
            filter = {
                _s_category_id__in: category || null,
                _s_province_id__in: this._s_province_id__in ||null,
                _s_tag_985: this._s_tag_985 ||null,
                _s_tag_211: this._s_tag_211 ||null,
                _s_memberof: this._s_memberof ||null,
                _s_type: this._s_type ||null,
                _s_tag_double_top:this._s_tag_double_top ||null,
            };
        }
        this.props.onFilter(filter);
    }

    handleResetFilter() {
        this.setState({
            area: '',
            category: '',
            type: '',
            tag985: false,
            tag211: false,
            tagMemberof: false,
            tagDoubleTop:false,
            checkedList:[],
        });
    }

    handleHideFilter() {
        this.props.onHide()
    }
    checkedItem(e,id){
        e.stopPropagation();
        let {checkedList}=this.state;
        if(checkedList.indexOf(id)>-1||checkedList.indexOf(id+'')>-1) {
            checkedList.splice(checkedList.indexOf(id), 1)
        }else {
            checkedList.push(id);
        }
        if(this.props.filterItem==='level'){
            if(checkedList.includes(10)||checkedList.includes('10')){this.setState({type:10,tag985:false,tag211:false,tagDoubleTop:false})}
            if(checkedList.includes(20)||checkedList.includes('20')){this.setState({type:20})}
            if(checkedList.includes(985)||checkedList.includes('985')){this.setState({tag985:true,type:20})}
            if(checkedList.includes(211)||checkedList.includes('211')){this.setState({tag211:true,type:20})}
            if(checkedList.includes(999)||checkedList.includes('999')){this.setState({tagDoubleTop:true,type:20})}
        }else if(this.props.filterItem==='province'){
            let area=checkedList.join();
            this.setState({area})
        }else if(this.props.filterItem==='category'){
            let category=checkedList.join();
            this.setState({category})
        }
        this.setState({checkedList})
    }
    dealLevel=(currentId)=>{
        const {checkedList,} = this.state;
        return ((checkedList.indexOf(10)>-1||checkedList.indexOf('10')>-1)&&this.props.filterItem=='level'&&([985,211,999,20].includes(currentId)))
            ||
            ((checkedList.indexOf(20)>-1||checkedList.indexOf('20')>-1)&&this.props.filterItem=='level'&&([10].includes(currentId)))
            ||
            ((checkedList.indexOf(985)>-1||checkedList.indexOf('985')>-1)&&this.props.filterItem=='level'&&([10].includes(currentId)))
            ||
            ((checkedList.indexOf(211)>-1||checkedList.indexOf('211')>-1)&&this.props.filterItem=='level'&&([10].includes(currentId)))
            ||
            ((checkedList.indexOf(999)>-1||checkedList.indexOf('999')>-1)&&this.props.filterItem=='level'&&([10].includes(currentId)))
    };
    render() {
        const {
            filterItems,
            checkedList,
        } = this.state;
        return (
            <div className="filter-pop" onClick={(e)=>{e.stopPropagation()}}>
                <div className='filter-items'>
                    {filterItems.map((i,index)=>{
                        return <div className='equipartition' key={index}
                                    style={{color:this.dealLevel(i.id)?'#ccc':'#4a4a4a'}}
                                    onClick={e=>{this.dealLevel(i.id)?console.log('禁选'):this.checkedItem(e,i.id)}}
                        >
                            <input
                                type="checkbox"
                                id={i.id}
                                checked={checkedList.indexOf(i.id)>-1||checkedList.indexOf(i.id+'')>-1}
                                disabled={this.dealLevel(i.id)&&true}
                            />
                            <span >{i.name}</span>
                        </div>
                    })}
                </div>
                <p className="btn-wrapper">
                    <button className="" onClick={this.handleResetFilter.bind(this)}>重置筛选</button>
                    <button className="primary" onClick={this.handleFilter.bind(this)}>确定</button>
                </p>
            </div>
        )
    }
}

Filters.defaultProps = {};

export default Filters



// WEBPACK FOOTER //
// ./src/pages/School/List/Filters.js